import request from 'utils/request'

// 查询内外部评分转化规则
export const page = type => request().get(`conversion/page/${type}`)
// 新增得分等级风险
export const addTable = data => request().post('conversion/add', data)
// 修改得分等级风险
export const update = data => request().post('conversion/update', data)